﻿const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
        }, wait);
    };
}

document.addEventListener('DOMContentLoaded', function () {
    var form = $('form.main-subscription-registration-form').length == 1 ? $('form.main-subscription-registration-form') : $('form.js-aspnet-form'); //check if the US 'new' version specifically existis, else get the default.
    var emailElements = $('.js-form .email');
    //DIG46 - Preference center - email check done to prevent triggering of checkEmail call unless a valid email is added
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const debouncedEmailChange = debounce(emailChanged, 300);
    emailElements.keyup(function () {
        if (regex.test(emailElements.val())) {
            debouncedEmailChange(form, emailElements)
        }
    });

    var getSubscriptionsJsonResultsUrl = function (micrositeId) {
        var urls = {
            'us': '/common/SubscriptionsElementData/GetSubscriptionDetails',
            'ucits': '/common/SubscriptionsElementData/GetSubscriptionDetails',
            'audiencehomepage': '/common/SubscriptionsElementData/GetSubscriptionDetails'
        };
        return urls[micrositeId];
    };
    var url = getSubscriptionsJsonResultsUrl(emailElements.attr('data-microsite-id'));

    var emailElement = $('.js-form .email');
    var investorTypeElement = $('.js-form .InvestorType');
    var countryElement = $('.js-form .Country');
    var certifiedFP = $('.js-form .CertifiedFinancialProfessional');

    $.post(url,
        {
            investorType: investorTypeElement.val(),
            email: emailElement.val(),
            siteContextType: $('#hdnCurrentSiteContextType').val(),
            country: countryElement.val(),
            formType: 'create'
        })
        .done(function (data) {
            vaneck.membership.fillSubscriptionElementBody(data.Result);

            //There could be more than one form on the page, therefore we take the form that has the investor type or country.
            var mainForm = (investorTypeElement.length != 0 && investorTypeElement.closest(".js-form")) || (countryElement.length != 0 && countryElement.closest(".js-form")) || $(".react-subscription-page .main-subscription-registration-form");
            if(mainForm.length != 1) return console.error("Error updating subscriptions, unable for find the the right form.")

            var formSubmitElement = mainForm.find('.FormSubmitButton');
            if (data.SubscriptionCount === 0) {
                formSubmitElement.prop('disabled', true);
            }
            else {
                formSubmitElement.removeAttr('disabled');
            }
        });

    vaneck.membership.initializeSpinner();
    vaneck.membership.drawRequiredMark(true);

    function emailChanged($form, $emailInput) {
        var email = $emailInput.val();

        if (email) {
            epi.EPiServer.Forms.validateField($form, $emailInput, email);
        }
    }

    /** Show the viewport wide spinner when the main subscritpion form is being submitted. */
    document.addEventListener('episerverFormEvent', function (e) {
        if (e.detail.type != "formsStartSubmitting") {
            return false;
        }
        if (e.detail.workingFormInfo.$workingForm.hasClass("main-subscription-registration-form")) {
            doSpinner()
        }
    })
});

$(document).ready(function () {
    var fpTopDiv = $('div[investortype="Individual Investor"]');
    fpTopDiv.addClass('FormChoice top-CertifiedFinancialProfessional');
    fpTopDiv.find('input').addClass('CertifiedFinancialProfessional');

    var firstNameElement = $('.js-form .FirstName');
    var lastNameElement = $('.js-form .LastName');

    var investorTypeElement = $('.js-form .InvestorType');
    var countryElement = $('.js-form .Country');
    var certifiedFP = $('.js-form .CertifiedFinancialProfessional');
    var IndividualInvestor = 'Individual Investor';
    var FinancialAdvisor = 'Financial Advisor';
    var Institutional = 'Institutional';
    var RIA = 'RIA';
    var userInvestorType = $.trim($('#hdnSelectedAudience').val());
    var userCountry = $.trim($('#hdnCurrentCountryIso3').val());

    //There could be more than one form on the page, therefore we take the form that has the investor type or country.
    var mainForm = (investorTypeElement.length != 0 && investorTypeElement.closest(".js-form")) || (countryElement.length != 0 && countryElement.closest(".js-form")) || $(".react-subscription-page .main-subscription-registration-form");
    if (mainForm.length != 1) return console.error("Error, unable to find the the right form.")

    var formSubmitElement = mainForm.find('.FormSubmitButton');
    var emailElement = mainForm.find('.email');

    window.isCorp = $('.js-form .email').attr('data-microsite-id') === 'audiencehomepage';
    window.isUCITS = userCountry !== "USA" && !isCorp;
    window.isUS = userCountry === "USA";
    userInvestorType = investorTypeElement.val();

    function setFPtext(fplbl, fpTxt, country, investorType) {
        country = country.toLowerCase();
        if (typeof (fpCustomText) !== 'undefined' && typeof (fpCustomText[country]) !== 'undefined') {
            fplbl != null && fplbl.text(fpTxt.replace('[fpCustomText]', fpCustomText[country]));
            showCertifiedFP(true);
        } else {
            fplbl != null && fplbl.text(fpTxt.replace('[Investor]', '"Investor"'));
            showCertifiedFP(false);
        }
    }

    var fpLabel = fpTopDiv.find('label');
    var fpText = fpTopDiv.find('label').text();

    var hdnInvestorTypeSelect = $('input.InvestorTypeSelect');
    hdnInvestorTypeSelect.val(userInvestorType);

    var fp = [];
    var ii = [];
    var investorType = [];
    var loadII = true;
    if (!isUCITS && !isCorp) {
        //countryElement.children().each(function () {
        //    if (loadII) {
        //        if ($(this).text() === '----') {
        //            loadII = false;
        //            console.log(countryElement);
        //            if (ii.length > 0)
        //                fp.push(ii[0]);
        //        } else {
        //            ii.push({ text: $(this).text(), value: $(this).val() });
        //        }

        //    } else {
        //        fp.push({ text: $(this).text(), value: $(this).val() });
        //    }
        //});
        //countryElement.empty();
            } else {
        var countryButtonEle = $('.top-Country .dropdown-menu.dropdown__menu');
        countryButtonEle.find('button').each(function () {
            if ($(this).attr('value') === userCountry) {
                $(this).click();
            }
        });
    }

    investorTypeElement.val(userInvestorType);
    (isUCITS || isCorp) && investorTypeElement.find('option').first().attr("disabled", "true");
    showDisclosure();

    //fired only in the US.
    investorTypeElement.on('customDropdownChange', function () { refreshForm(); PopulateSubscriptions(); });
    countryElement.on('customDropdownChange', function () { refreshForm(); PopulateSubscriptions(); });
    /*
    investorTypeElement.children().each(function () {
        investorType.push({ text: $(this).text(), value: $(this).val() });
    });
    investorTypeElement.empty();
    */
    if (isUCITS || isCorp) { firstNameElement.focus(); } else { emailElement.focus(); }
    refreshForm();
    /*
    emailElement.prop('disabled', 'disabled');
    investorTypeElement.prop('disabled', 'disabled');
    countryElement.prop('disabled', 'disabled');
    formSubmitElement.prop('disabled', 'disabled');
    certifiedFP.parent().hide();
    */
    function disableElement(element) {
        element.prop('disabled', true);
    }

    function enableElement(element) {
        element.removeAttr('disabled');
    }

    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function refreshForm() {
        //Disable the email element when first and last name is not provided. (UCITS only)
        if (isUCITS) {
            if ($.trim(firstNameElement.val()).length === 0 || $.trim(lastNameElement.val()).length === 0) {
                //Commented the below line due to changes on WEBEU-2562
                //emailElement.val('');
                disableElement(emailElement);
            } else {
                enableElement(emailElement);
            }
        }

        if (!isUCITS && !isCorp) {
            if (!(isEmail($.trim(emailElement.val())))) {
                disableElement(countryElement);
                showCountry(false);
                $('.InvestorTypeSelect ~ button.dropdown__button').addClass('disabled');
            } else {
                enableElement(countryElement);
                showCountry(true);
                $('.InvestorTypeSelect ~ button.dropdown__button').removeClass('disabled');
            }
        }
        
        if (!isUCITS && !isCorp) {
            if ([IndividualInvestor, " "].includes($(investorTypeElement).val())) {
                showCertifiedFP(false);
            } else if ($('.react-subscription-page #hdnSelectedAudience').val() == "retail") {
                showCertifiedFP(false);
            }
            else {
                showCertifiedFP(true);
            }
        }

        if (isUS) {
            if ([FinancialAdvisor, Institutional, RIA, " "].includes($(investorTypeElement).val())) {
                showCertifiedFP(true);
            } else {
                showCertifiedFP(false);
            }
        }

        if ($.trim(countryElement.val()).length !== 0) {
            checkCertifiedFP();
        }
    }

    function checkCertifiedFP() {
        if ([IndividualInvestor, " "].includes($(investorTypeElement).val())) {
            if (!certifiedFP.prop('checked')) {
                if (investorTypeElement.val() !== null && !isUCITS && !isCorp) {
                    //certifiedFP.focus();
                    //disableElement(formSubmitElement);
                }
            }
        }
    }

    if (isUCITS || isCorp) {
        firstNameElement.keyup(function () {
            refreshForm();
        });

        lastNameElement.keyup(function () {
            refreshForm();
        });
    }


    if (!isUCITS && !isCorp) {
        emailElement.keyup(function (e) {

            if (!((e.keyCode == 17) || (e.keyCode == 65 && e.ctrlKey) || (e.keyCode == 67 && e.ctrlKey) || (e.keyCode == 86 && e.ctrlKey) || (e.keyCode == 9))) {
                /*
                investorTypeElement.empty();
                disableElement(investorTypeElement);
                */
                populateCountries('');
                refreshForm();
            }
        });
    }

        
    if (!isUCITS) {
        //DIG46 - Preference center - email check done to prevent triggering of checkEmail call unless a valid email is added
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            emailElement.keyup(debounce(function (e) {
            if (regex.test(emailElement.val())) {
            PopulateSubscriptions();
            }
        }, 700));
    }

    var lastSelection;

    function onFormElementFocus() {
        lastSelection = investorTypeElement.val();
    }

    function onFormElementChange(arrOfFunctions) {
        arrOfFunctions.forEach(function (f) {
            f();
        })
        if (isUCITS && typeof (setFPtext) !== 'undefined') {
            setFPtext(fpLabel, '*' + fpText, countryElement.find("option:selected").text(), investorTypeElement.find("option:selected").text());
        }
    }

    const formElements = [investorTypeElement, countryElement];

    formElements.forEach(function (f) {
        f.focus(function () {
            (f === investorTypeElement) && onFormElementFocus();
        }).change(function () {
            (f === countryElement) ? onFormElementChange([PopulateSubscriptions]) : onFormElementChange([showDisclosure,PopulateSubscriptions]);
        });
    });

    function PopulateSubscriptions() {

        hdnInvestorTypeSelect.val(investorTypeElement.val());
        refreshForm();

        var url = getSubscriptionsDetailsUrl(emailElement.attr('data-microsite-id'));
        $.post(url,
            {
                investorType: investorTypeElement.val(),
                email: emailElement.val(),
                siteContextType: $('#hdnCurrentSiteContextType').val(),
                country: countryElement.val()
            })
            .done(function (data) {
                const customGlobalEvent = new CustomEvent("SubscriptionsReceivedEvent", { detail: data, bubbles: false });
                document.dispatchEvent(customGlobalEvent);

                var status = data.Status.toUpperCase();

                if (status === "AVAILABLE") {
                    vaneck.membership.fillSubscriptionElementBody(data.Result);
                    if (data.SubscriptionCount === 0) {
                        disableElement(formSubmitElement);
                    }
                    else {
                        enableElement(formSubmitElement);
                    }
                }  
                
                if (!isCorp && !isUCITS) {
                    populateCountries(lastSelection);
                }
            });
       
    }

    var getSubscriptionsDetailsUrl = function (micrositeId) {
        var urls = {
     'us': '/common/SubscriptionsElementData/GetSubscriptionsDetails',
            'ucits': '/common/SubscriptionsElementData/GetSubscriptionsDetails',
            'audiencehomepage': '/common/SubscriptionsElementData/GetSubscriptionsDetails'
        };
        return urls[micrositeId];
    };

    countryElement.change(function () {
        refreshForm();
        var selectedCountry = $(this).find("option:selected").text();
        if (isUCITS && typeof (setFPtext) !== 'undefined') {
            setFPtext(fpLabel, '*' + fpText, selectedCountry, investorTypeElement.find("option:selected").text());
        }
    });

    function changeDropdown(dropdown, selectedVal) {
        dropdown.find("option").removeAttr("selected");
        dropdown.find("option").each(function () {
            if ($(this).attr('value') == selectedVal) {
                $(this).attr("selected", "selected");
                $(this).prop("selected", true);
                $(dropdown).prop("value", selectedVal);
            }
        });
    }

    function regenCountry(audience) {
        var currentCountry = $('select.Country').val();
        countryElement.empty();
        $.each(audience, function (key, item) {
            var option = new Option(item.text, item.value);
            countryElement.append($(option));
        });
        if (currentCountry != "" && currentCountry != null && $('select.Country').length > 0) {
            /**
             * Country had already been selected before the select dropdowns were refreshed, this needs to be reinstated.
             */
            changeDropdown($('select.Country'), currentCountry);
        } else {
            const ctext = $("#select-country-text").text().trim(); //current AHO country
            //Find the ISO3 code of the country.
            const iso3 = $('.js-form .Country').find('option').toArray().find(x => $(x).text().trim() === ctext)?.value
            if (iso3) {
                changeDropdown($('select.Country'), iso3);
            }
            
        }
    }

    function showCountry(show) {
        if (show && $('.top-Country').hasClass('hide')) {
            $('.top-Country').removeClass('hide');
            return;
        }
        if (!show) {
            $('.top-Country').addClass('hide');
        }
    }

    function populateCountries(lastSelection) {
        if ($(investorTypeElement).val() != '') {
            if (isUCITS) {
                setFPtext(null, '', countryElement.find("option:selected").text(), investorTypeElement.find("option:selected").text());
            } else {
                if ([IndividualInvestor, " "].includes($(investorTypeElement).val())) {
                    showCertifiedFP(false);
                    //if (!isUCITS && (lastSelection != IndividualInvestor || lastSelection === '')) {
                    //    regenCountry(ii);
                    //}
                } else {
                    certifiedFP.parent().show();
                    //if (!isUCITS && (lastSelection === IndividualInvestor || lastSelection === '')) {
                    //    regenCountry(fp);
                    //}
                    }
                }
            }
        //Trigger the conversion of the dropdown to a custom version (if applicable i.e. US), only once once the above logic is complete.
        customDropdown.init(".custom-select-form", ".dropdown-delayed");
        $('.dropdown-delayed').removeClass('dropdown-delayed').addClass('dropdown location-dd');
        //$('.top-Country').removeClass('hide');
    }

    function showCertifiedFP(show) {
        if (show) {
            if (isUCITS || isCorp) {
                certifiedFP.parent().css('display', 'inline-block');
            }
            else {
                certifiedFP.removeClass('hide');
            }
        } else {
            if (!isUCITS && !isCorp) {
                certifiedFP.addClass('hide');
                return;
            }
            certifiedFP.parent().css('display', 'none');
            certifiedFP.prop("checked", false);
        }

    }

    function isDisclosureUsing() {
        return $('.js-form .js-Disclosure').length > 0;
    }

    function showDisclosure() {
        if (isDisclosureUsing()) {
            if ([IndividualInvestor, " "].includes($(investorTypeElement).val())) {
                showDisclosureType("II");
            } else {
                showDisclosureType("FP");
            }
        }        
    }      

    certifiedFP.change(function () {
        refreshForm();
    });

    formSubmitElement.focus(function () {
        lastSelection = investorTypeElement.val();
    }).click(function () {
        if (![IndividualInvestor, " "].includes($(investorTypeElement).val())) {
            if (certifiedFP.length > 0 && !certifiedFP.prop('checked')) {
                if (investorTypeElement.val() !== null && investorTypeElement.val() !== '') {
                    certifiedFP.focus();
                }
                return false;
            }
        }
    });
    if (isUCITS && typeof (setFPtext) !== 'undefined') {
        setFPtext(fpLabel, fpText, userCountry, investorTypeElement.find("option:selected").text());
    }
});


/* REcaptcha checker
 * Code to listen for whether the recaptcha element is done with it's validation and then to manually trigger the resubmission of the form.
 */
    //Recaptcha Code moved to generic-invisible-recaptcha-v2 for au compatibility.
window.subsPopover = function() {
    $('.more-info-icon-svg').each(function (i, e) {
        var $ele = $(e),
            $popoverLink = $ele.next('.subscription-tooltip-content'),
            popoverID = 'popoverid' + String(Math.random()).substr(2);
        $(this).attr('id', popoverID);
        $popoverLink.attr('id', ('po' + popoverID));
        $ele.popover({
            html: true,
            trigger: 'hover',
            container: '.registration_body',
            content: function () {
                var id = $(this).attr('id');
                return $('#po' + id).html();
            },
            popperConfig: {
                placement: 'right-start',
            },
        });
    });
}
 
/*
 * End
 */

//document.addEventListener('DOMContentLoaded', function () {
//    //check if this is individual investor
//    $(".react-subscription-page .main-subscription-registration-form .CertifiedFinancialProfessional.FormChoice").each(function () {
//        if ($("#hdnSelectedAudience").val() == "retail") {
//            $(this).hide();
//        }
//    })
//});
